export const InstagramUrl = 'https://www.instagram.com/khanoumi_shop'
export const LinkedinUrl = 'https://www.linkedin.com/company/khanoumi'
export const TelegramUrl = 'https://t.me/khanoumi_com'
export const BaleUrl = 'https://ble.ir/khanoumishop'
export const Email = 'info@khanoumi.com'

export const primaryPhoneNumber = {
    value: '02191200500',
    delimited: '021-91200500',
}

export const secondaryPhoneNumber = {
    value: '02192005221',
    delimited: '021-92005221',
}
